import { render, staticRenderFns } from "./ChooseName.vue?vue&type=template&id=c126e3d6&scoped=true&"
import script from "./ChooseName.vue?vue&type=script&lang=js&"
export * from "./ChooseName.vue?vue&type=script&lang=js&"
import style0 from "./ChooseName.vue?vue&type=style&index=0&id=c126e3d6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c126e3d6",
  null
  
)

export default component.exports